// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-autocomplete {
  display: inline-flex;
  position: relative;
}

.p-autocomplete-loader {
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
}

.p-autocomplete-dd .p-autocomplete-input {
  flex: 1 1 auto;
  width: 1%;
}
.p-autocomplete-dd .p-autocomplete-dropdown {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0px;
}

.p-autocomplete-dd .p-autocomplete-input,
.p-autocomplete-dd .p-autocomplete-multiple-container {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.p-autocomplete-panel {
  overflow: auto;
}

.p-autocomplete-items {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.p-autocomplete-item {
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}

.p-autocomplete-multiple-container {
  margin: 0;
  padding: 0;
  list-style-type: none;
  cursor: text;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.p-autocomplete-token {
  cursor: default;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}

.p-autocomplete-token-icon {
  cursor: pointer;
}

.p-autocomplete-input-token {
  flex: 1 1 auto;
  display: inline-flex;
}
.p-autocomplete-input-token input {
  border: 0 none;
  outline: 0 none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  width: 100%;
}

.p-fluid .p-autocomplete {
  display: flex;
}
.p-fluid .p-autocomplete-dd .p-autocomplete-input {
  width: 1%;
}

.p-autocomplete-clear-icon {
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
  cursor: pointer;
  right: 10px;
}

.p-autocomplete-clearable {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gc-autocomplete/autocomplete.sass"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,kBAAA;AACJ;;AAAA;EACI,kBAAA;EACA,QAAA;EACA,mBAAA;AAGJ;;AADI;EACI,cAAA;EACA,SAAA;AAIR;AAHI;EACI,yBAAA;EACA,8BAAA;AAKR;;AAJA;;EAEI,0BAAA;EACA,6BAAA;AAOJ;;AANA;EACI,cAAA;AASJ;;AARA;EACI,SAAA;EACA,UAAA;EACA,qBAAA;AAWJ;;AAVA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAaJ;;AAZA;EACI,SAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAeJ;;AAdA;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAiBJ;;AAhBA;EACI,eAAA;AAmBJ;;AAlBA;EACI,cAAA;EACA,oBAAA;AAqBJ;AApBI;EACI,cAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAsBR;;AApBI;EACI,aAAA;AAuBR;AArBQ;EACI,SAAA;AAuBZ;;AAtBA;EACI,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAyBJ;;AAxBA;EACI,kBAAA;AA2BJ","sourcesContent":[".p-autocomplete\n    display: inline-flex\n    position: relative\n.p-autocomplete-loader\n    position: absolute\n    top: 50%\n    margin-top: -.5rem\n.p-autocomplete-dd\n    .p-autocomplete-input\n        flex: 1 1 auto\n        width: 1%\n    .p-autocomplete-dropdown\n        border-top-left-radius: 0\n        border-bottom-left-radius: 0px\n.p-autocomplete-dd .p-autocomplete-input,\n.p-autocomplete-dd .p-autocomplete-multiple-container\n    border-top-right-radius: 0\n    border-bottom-right-radius: 0\n.p-autocomplete-panel\n    overflow: auto\n.p-autocomplete-items\n    margin: 0\n    padding: 0\n    list-style-type: none\n.p-autocomplete-item\n    cursor: pointer\n    white-space: nowrap\n    position: relative\n    overflow: hidden\n.p-autocomplete-multiple-container\n    margin: 0\n    padding: 0\n    list-style-type: none\n    cursor: text\n    overflow: hidden\n    display: flex\n    align-items: center\n    flex-wrap: wrap\n.p-autocomplete-token\n    cursor: default\n    display: inline-flex\n    align-items: center\n    flex: 0 0 auto\n.p-autocomplete-token-icon\n    cursor: pointer\n.p-autocomplete-input-token\n    flex: 1 1 auto\n    display: inline-flex\n    input\n        border: 0 none\n        outline: 0 none\n        background-color: transparent\n        margin: 0\n        padding: 0\n        box-shadow: none\n        border-radius: 0\n        width: 100%\n.p-fluid\n    .p-autocomplete\n        display: flex\n    .p-autocomplete-dd\n        .p-autocomplete-input\n            width: 1%\n.p-autocomplete-clear-icon\n    position: absolute\n    top: 50%\n    margin-top: -.5rem\n    cursor: pointer\n    right: 10px\n.p-autocomplete-clearable\n    position: relative\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
